import React from "react";
import { useMediaQuery } from "react-responsive";
import { Link } from "react-router-dom";

function VerificationInfo() {
  const isLaptop = useMediaQuery({ query: "(max-width: 1350px)" });

  return (
    <div className="flex plan-expired flex align-center space-between ">
      <div className="full-width align-center flex">
        <span className="flex align-center justify-center announcement-banner">
          <b className="white-text">Account not verified.</b>
        </span>

        <span className="announcement-banner-title">&nbsp;</span>

        <b className={`${isLaptop ? "p-1 font-14px" : "p-2"}`}>
          <span className="announcement-banner-message">
            Please verify your account to access all features.
          </span>
        </b>
      </div>

      <Link
        className=""
        style={{
          width: "130px",
          marginRight: "10px",
        }}
     to={"/documents/showDetails"}
      >
        {" "}
        Verify Now
      </Link>
    </div>
  );
}

export default VerificationInfo;
